import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "groups"]

  static values = {
    url: String,
    minCharacters: { type: Number, default: 3 },
    debounce: { type: Number, default: 300 }
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.perform(), this.debounceValue)
  }

  async perform() {
    const query = this.inputTarget.value.trim()

    if (query.length < this.minCharactersValue) {
      this.showGroups()
      return
    }

    this.showResults()

    try {
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set("query", query)

      const response = await fetch(url, {
        headers: { Accept: "text/vnd.turbo-stream.html" },
        credentials: "same-origin"
      })

      if (!response.ok) throw new Error(`Search failed: ${response.status}`)

      Turbo.renderStreamMessage(await response.text())
    } catch (error) {
      console.error(error)
    }
  }

  showResults() {
    if (this.hasGroupsTarget) this.groupsTarget.classList.add("hidden")
    this.resultsTarget.classList.remove("hidden")
  }

  showGroups() {
    this.resultsTarget.classList.add("hidden")
    this.resultsTarget.innerHTML = ""
    if (this.hasGroupsTarget) this.groupsTarget.classList.remove("hidden")
  }
}
